export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtSN';
export const NAME = 'ServisniPakety';

export const SERVISNI_PAKETY_ND = 'ServisniPaketyNd';
export const SERVISNI_PAKETY_PP = 'ServisniPaketyPp';
export const SERVISNI_PAKETY_DRUH = 'ServisniPaketyDruh';

export const DEPENDENT_TABLES = <const>[
	SERVISNI_PAKETY_DRUH,
	SERVISNI_PAKETY_ND,
	SERVISNI_PAKETY_PP,
];
